import styled from "styled-components";

export const Divider = styled.div`
  width: 100%;
  height: 0.34px;
  min-height: 0.5px;
  background: ${(props) => props.theme.color.secondaryText};
`;
